import {HTMLProps, PropsWithChildren} from "react";
import {useNavigate} from "react-router-dom";

interface ButtonProps extends PropsWithChildren, HTMLProps<HTMLElement> {
    onClick?: () => void;
    navTo?: string;
}


export default function Button({className, navTo, onClick, children}: ButtonProps) {

    const nav = useNavigate();

    function handleClick() {
        if (navTo) {
            nav(navTo);
        } else if (onClick) {
            onClick();
        }
    }

    return (
        <button
            type="button"
            onClick={handleClick}
            className={`bg-engage-400 hover:bg-engage-500 active:bg-engage-600 text-white font-bold py-3 px-4 rounded-lg border border-engage-500 touch-manipulation ${className || ""}`}
        >
            {children}
        </button>
    );
}